import Api from "~/service/Api";

class PhotoEditingLabelRepository {
  create(data) {
    return Api.post("/photo-editing/labels", {
      photoEditingJobId: data.photoEditingJobId,
      name: data.name,
    });
  }

  delete(photoEditingLabelId) {
    return Api.delete(`/photo-editing/labels/${photoEditingLabelId}`);
  }
}

export default PhotoEditingLabelRepository;
